import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, useMediaQuery, Dialog, Slide } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { TransitionProps } from '@material-ui/core/transitions';
import { String_System_Ok, String_Check_ServiceChargePopup } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions'
import FullWidthButton, { FullWidthButtonProps, FullWidthButtonSize } from '../common/Buttons/FullWidthButton';

const useStyles = makeStyles({
    details: {
        padding: '10px',
    },
    dialog: {
        backgroundColor: themePrimary.palette.secondary.light,
    },
    dialogLandscape: {
        backgroundColor: themePrimary.palette.secondary.light,
        left: 'calc(100vw *.3) !important',
        width: 'calc(100vw *.7)',
    },
    button: {
        marginTop: '20px',
    },
    instructionText: {
        marginTop: ElementDimensions.margin10 + 'px',
        marginBottom: ElementDimensions.margin10 + 'px',
        textAlign: 'center',
        fontFamily: 'LeagueSpartan-Regular !important',
      },
});

export type ServiceChargeDialogCloseClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface ServiceChargeDialogProps {
    open: boolean;
    message: string;
    onCloseHandler: ServiceChargeDialogCloseClickHandler;
}

const ServiceChargeDialog = (props: ServiceChargeDialogProps) => {
    const { open, message, onCloseHandler } = props;
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    React.useEffect(() => {

    });

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        onCloseHandler(event);
    };

    const buttonProps: FullWidthButtonProps = {
        disabled: false,
        label: String_System_Ok.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: handleClose,
    }

    return (
        <Dialog open={open} onClose={handleClose} className={isPortrait === true ? classes.dialog : classes.dialogLandscape}>
            <div className={classes.details}>
                <Typography variant="h6" className={classes.instructionText}>
                    {message}
                </Typography>
                <div className={classes.button}>
                    <FullWidthButton 
                        disabled={buttonProps.disabled}
                        label={buttonProps.label}
                        alternateColor={buttonProps.alternateColor}
                        size={buttonProps.size}
                        onClickHandler={buttonProps.onClickHandler} />
                </div>
            </div>
        </Dialog>
    );
};

export default ServiceChargeDialog;